/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLocation } from "react-router";
import { io, Socket } from "socket.io-client";
import { toast } from "react-toastify";
import { config } from "./config";
import {
  UserType,
  BettedUserType,
  GameHistory,
  ContextType,
  ContextDataType,
  MsgUserType,
  GameBetLimit,
  UserStatusType,
  GameStatusType,
  SeedDetailsType,
  unityContext as sharedUnityContext,
  init_state as sharedInitState,
  init_userInfo,
} from "./utils/interfaces";

// Sound utility
const getAudio = (id: string): HTMLAudioElement | null => document.getElementById(id) as HTMLAudioElement | null;
const playSound = (id: string) => {
  try {
    const el = getAudio(id);
    if (el) { el.currentTime = 0; el.play().catch(() => {}); }
  } catch(e) {}
};
const isSoundOn = () => localStorage.getItem("aviator-sound") !== "false";

// Unlock audio on first user interaction
let audioUnlocked = false;
const unlockAudio = () => {
  if (audioUnlocked) return;
  audioUnlocked = true;
  ["mainAudio","takeOffAudio","flewAwayAudio","cashoutAudio"].forEach(id => {
    const el = document.getElementById(id) as HTMLAudioElement | null;
    if (el) { el.play().catch(() => {}); el.pause(); el.currentTime = 0; }
  });
};
document.addEventListener("click", unlockAudio, { once: true });
document.addEventListener("keydown", unlockAudio, { once: true });

export interface PlayerType {
  auto: boolean;
  betted: boolean;
  cashouted: boolean;
  betAmount: number;
  cashAmount: number;
  target: number;
}

const Context = React.createContext<ContextType>(null!);

const socket: Socket = io(window.location.origin, {
  transports: ["websocket", "polling"],
  autoConnect: true,
  timeout: 20000,
  forceNew: false,
});

export const callCashOut = (at: number, index: "f" | "s") => {
  let data = { type: index, endTarget: at };
  socket.emit("cashOut", data);
};

let fIncreaseAmount = 0;
let fDecreaseAmount = 0;
let sIncreaseAmount = 0;
let sDecreaseAmount = 0;

let newState: any;
let newBetState: any;

export const Provider = ({ children }: any) => {
  const token = new URLSearchParams(useLocation().search).get("cert");

  // Restore session from localStorage on page load
  React.useEffect(() => {
    const savedToken = localStorage.getItem("aviator-token");
    const savedName = localStorage.getItem("aviator-username");
    const savedBalance = localStorage.getItem("aviator-balance");
    if (savedToken && savedName) {
      setUserInfo((prev: any) => ({ ...prev, token: savedToken, userName: savedName, balance: savedBalance ? Number(savedBalance) : 0, currency: "KSh" }));
      setState((prev: any) => ({ ...prev, userInfo: { ...prev.userInfo, balance: savedBalance ? Number(savedBalance) : 0 } }));
    }
  }, []);
  const [state, setState] = React.useState<ContextDataType>(sharedInitState);
  const [userInfo, setUserInfo] = React.useState<UserType>(init_userInfo);
  const [msgData, setMsgData] = React.useState<MsgUserType[]>([]);
  const [msgTab, setMsgTab] = React.useState<boolean>(window.innerWidth >= 768);
  const [msgReceived, setMsgReceived] = React.useState<boolean>(false);
  const [platformLoading, setPlatformLoading] = React.useState<boolean>(false);
  const [errorBackend, setErrorBackend] = React.useState<boolean>(false);
  const [secure, setSecure] = React.useState<boolean>(false);
  const [userSeedText, setUserSeedText] = React.useState<string>("");
  const [globalUserInfo, setGlobalUserInfo] = React.useState<UserType>(init_userInfo);
  const [fLoading, setFLoading] = React.useState<boolean>(false);
  const [sLoading, setSLoading] = React.useState<boolean>(false);

  newState = state;

  const [unity, setUnity] = React.useState({
    unityState: true,
    unityLoading: true,
    currentProgress: 0,
  });

  const [gameState, setGameState] = React.useState({
    currentNum: "0",
    currentSecondNum: 0,
    GameState: "",
    time: 0,
  });

  const [bettedUsers, setBettedUsers] = React.useState<BettedUserType[]>([]);
  const update = (attrs: Partial<ContextDataType>) => {
    setState({ ...state, ...attrs });
  };
  const [previousHand, setPreviousHand] = React.useState<UserType[]>([]);
  const [history, setHistory] = React.useState<number[]>([]);
  const [userBetState, setUserBetState] = React.useState<UserStatusType>({
    fbetState: false,
    fbetted: false,
    sbetState: false,
    sbetted: false,
  });
  newBetState = userBetState;
  const [rechargeState, setRechargeState] = React.useState(false);
  const [onlineCount, setOnlineCount] = React.useState(1);
  const [currentTarget, setCurrentTarget] = React.useState(0);
  const updateUserBetState = (attrs: Partial<UserStatusType>) => {
    setUserBetState({ ...userBetState, ...attrs });
  };

  const [betLimit, setBetLimit] = React.useState<GameBetLimit>({
    maxBet: 1000,
    minBet: 1,
  });

  React.useEffect(function () {
    sharedUnityContext.on("loaded", () => {
      setUnity({ currentProgress: 100, unityLoading: true, unityState: true });
    });
    sharedUnityContext.on("error", (error) => {
      setUnity({ currentProgress: 0, unityLoading: true, unityState: true });
    });
    sharedUnityContext.on("GameController", function (message) {
      if (message === "Ready") {
        setUnity({ currentProgress: 100, unityLoading: true, unityState: true });
      }
    });
    sharedUnityContext.on("progress", (progression) => {
      const currentProgress = progression * 100;
      if (progression === 1) {
        setUnity({ currentProgress, unityLoading: true, unityState: true });
      } else {
        setUnity({ currentProgress, unityLoading: true, unityState: false });
      }
    });
    return () => sharedUnityContext.removeAllEventListeners();
  }, []);

  React.useEffect(() => {
    socket.on("connect", () => {
      setErrorBackend(false);
      const activeToken = token || localStorage.getItem("aviator-token") || "";
      socket.emit("enterRoom", { token: activeToken });
    });
    socket.on("disconnect", () => { setErrorBackend(true); });
    socket.on("connect_error", () => { setErrorBackend(true); });
    socket.on("bettedUserInfo", (bettedUsers: BettedUserType[]) => {
      setBettedUsers(bettedUsers);
    });
    socket.on("myBetState", (user: UserType) => {
      const attrs = userBetState;
      attrs.fbetState = false;
      attrs.fbetted = user.f.betted;
      attrs.sbetState = false;
      attrs.sbetted = user.s.betted;
      setUserBetState(attrs);
    });
    socket.on("myInfo", (user: UserType) => {
      let attrs = state;
      attrs.userInfo.balance = user.balance;
      attrs.userInfo.userType = user.userType;
      attrs.userInfo.userName = user.userName;
      update(attrs);
      setUserInfo((prev: any) => ({ ...prev, balance: user.balance }));
      localStorage.setItem("aviator-balance", String(user.balance));
    });
    socket.on("history", (history: any) => { setHistory(history); });
    socket.on("gameState", (gameState: GameStatusType) => {
      setGameState({ ...gameState, currentSecondNum: parseFloat(gameState.currentNum) || 0 });
      if (gameState.GameState === "PLAYING" && isSoundOn()) {
        const mainAudio = getAudio("mainAudio");
        if (mainAudio && mainAudio.paused) {
          mainAudio.volume = 0.2;
          mainAudio.play().catch(() => {});
          playSound("takeOffAudio");
        }
      }
      if (gameState.GameState === "GAMEEND" || gameState.GameState === "BET") {
        const mainAudio = getAudio("mainAudio");
        if (mainAudio) { mainAudio.pause(); mainAudio.currentTime = 0; }
      }
      if (gameState.GameState === "GAMEEND" && isSoundOn()) {
        playSound("flewAwayAudio");
      }
    });
    socket.on("previousHand", (previousHand: UserType[]) => { setPreviousHand(previousHand); });
    socket.on("finishGame", (user: UserType) => {
      let attrs = newState;
      let betStatus = newBetState;
      // Preserve current auto and betAmount settings
      const fauto = attrs.userInfo.f.auto;
      const sauto = attrs.userInfo.s.auto;
      const fbetAmount = attrs.userInfo.f.betAmount;
      const sbetAmount = attrs.userInfo.s.betAmount;
      const fBetted = betStatus.fbetted;
      const sBetted = betStatus.sbetted;
      // Only update balance from server
      attrs.userInfo.balance = user.balance;
      setUserInfo((prev: any) => ({ ...prev, balance: user.balance }));
      localStorage.setItem("aviator-balance", String(user.balance));
      // Merge only the fields that changed - preserve the other bet
      if (user.f) {
        attrs.userInfo.f = { ...attrs.userInfo.f, ...user.f, betAmount: fbetAmount, auto: fauto };
      }
      if (user.s) {
        attrs.userInfo.s = { ...attrs.userInfo.s, ...user.s, betAmount: sbetAmount, auto: sauto };
      }
      // Restore betted state for the bet that didn't finish
      if (!user.f || user.f.betted === undefined) betStatus.fbetted = fBetted;
      if (!user.s || user.s.betted === undefined) betStatus.sbetted = sBetted;
      if (!user.f.betted) {
        betStatus.fbetted = false;
        if (attrs.userInfo.f.auto) {
          if (user.f.cashouted) {
            fIncreaseAmount += user.f.cashAmount;
            if (attrs.finState && attrs.fincrease - fIncreaseAmount <= 0) {
              attrs.userInfo.f.auto = false;
              betStatus.fbetState = false;
              fIncreaseAmount = 0;
            } else if (attrs.fsingle && attrs.fsingleAmount <= user.f.cashAmount) {
              attrs.userInfo.f.auto = false;
              betStatus.fbetState = false;
            } else {
              attrs.userInfo.f.auto = true;
              betStatus.fbetState = true;
            }
          } else {
            fDecreaseAmount += user.f.betAmount;
            if (attrs.fdeState && attrs.fdecrease - fDecreaseAmount <= 0) {
              attrs.userInfo.f.auto = false;
              betStatus.fbetState = false;
              fDecreaseAmount = 0;
            } else {
              attrs.userInfo.f.auto = true;
              betStatus.fbetState = true;
            }
          }
        }
      }
      if (!user.s.betted) {
        betStatus.sbetted = false;
        if (attrs.userInfo.s.auto) {
          if (user.s.cashouted) {
            sIncreaseAmount += user.s.cashAmount;
            if (attrs.sinState && attrs.sincrease - sIncreaseAmount <= 0) {
              attrs.userInfo.s.auto = false;
              betStatus.sbetState = false;
              sIncreaseAmount = 0;
            } else if (attrs.ssingle && attrs.ssingleAmount <= user.s.cashAmount) {
              attrs.userInfo.s.auto = false;
              betStatus.sbetState = false;
            } else {
              attrs.userInfo.s.auto = true;
              betStatus.sbetState = true;
            }
          } else {
            sDecreaseAmount += user.s.betAmount;
            if (attrs.sdeState && attrs.sdecrease - sDecreaseAmount <= 0) {
              attrs.userInfo.s.auto = false;
              betStatus.sbetState = false;
              sDecreaseAmount = 0;
            } else {
              attrs.userInfo.s.auto = true;
              betStatus.sbetState = true;
            }
          }
        }
      }
      setState((prev: any) => ({ ...prev, ...attrs }));
      setUserBetState(betStatus);
    });
    socket.on("getBetLimits", (betAmounts: { max: number; min: number }) => {
      setBetLimit({ maxBet: betAmounts.max, minBet: betAmounts.min });
    });
    socket.on("recharge", () => { setRechargeState(true); });
    socket.on("onlineCount", (count: number) => { setOnlineCount(count); });
    socket.on("receiveMsg", (msg: any) => {
      setMsgData((prev: any) => [...prev, msg]);
    });
    socket.on("error", (data) => {
      setUserBetState({ ...userBetState, [`${data.index}betted`]: false });
      toast.error(data.message);
    });
    socket.on("success", (data) => {
      toast.success(data);
      if (String(data).includes("Cashed") && isSoundOn()) playSound("cashoutAudio");
    });

    return () => {
      socket.off("connect");
      socket.off("disconnect");
      socket.off("connect_error");
      socket.off("bettedUserInfo");
      socket.off("myBetState");
      socket.off("myInfo");
      socket.off("history");
      socket.off("gameState");
      socket.off("previousHand");
      socket.off("finishGame");
      socket.off("getBetLimits");
      socket.off("recharge");
      socket.off("receiveMsg");
      socket.off("onlineCount");
      socket.off("error");
      socket.off("success");
    };
  }, []);

  React.useEffect(() => {
    let attrs = state;
    let betStatus = userBetState;
    if (gameState.GameState === "BET") {
      if (betStatus.fbetState) {
        if (state.userInfo.f.auto) {
          if (state.fautoCound > 0) {
            attrs.fautoCound -= 1;
            setState((prev: any) => ({ ...prev, fautoCound: attrs.fautoCound }));
          } else {
            attrs.userInfo.f.auto = false;
            betStatus.fbetState = false;
            setState((prev: any) => ({ ...prev, userInfo: { ...prev.userInfo, f: { ...prev.userInfo.f, auto: false } } }));
            return;
          }
        }
        let data = {
          betAmount: state.userInfo.f.betAmount,
          target: state.userInfo.f.target,
          type: "f",
          auto: state.fautoCashoutState && state.userInfo.f.target > 1,
        };
        const activeToken1 = localStorage.getItem("aviator-token") || "";
        if (!activeToken1) {
          toast.error("Please login to place a bet");
          betStatus.fbetState = false;
          betStatus.fbetted = false;
          return;
        }
        const currentBalance1 = Number(localStorage.getItem("aviator-balance") || 0);
        if (currentBalance1 - state.userInfo.f.betAmount < 0) {
          toast.error("Your balance is not enough");
          betStatus.fbetState = false;
          betStatus.fbetted = false;
          return;
        }
        const newBalance1 = currentBalance1 - state.userInfo.f.betAmount;
        attrs.userInfo.balance = newBalance1;
        localStorage.setItem("aviator-balance", String(newBalance1));
        socket.emit("playBet", data);
        betStatus.fbetState = false;
        betStatus.fbetted = true;
        setUserBetState(betStatus);
      }
      if (betStatus.sbetState) {
        if (state.userInfo.s.auto) {
          if (state.sautoCound > 0) {
            attrs.sautoCound -= 1;
            setState((prev: any) => ({ ...prev, sautoCound: attrs.sautoCound }));
          } else {
            attrs.userInfo.s.auto = false;
            betStatus.sbetState = false;
            setState((prev: any) => ({ ...prev, userInfo: { ...prev.userInfo, s: { ...prev.userInfo.s, auto: false } } }));
            return;
          }
        }
        let data = {
          betAmount: state.userInfo.s.betAmount,
          target: state.userInfo.s.target,
          type: "s",
          auto: state.sautoCashoutState && state.userInfo.s.target > 1,
        };
        const activeToken2 = localStorage.getItem("aviator-token") || "";
        if (!activeToken2) {
          toast.error("Please login to place a bet");
          betStatus.sbetState = false;
          betStatus.sbetted = false;
          return;
        }
        const currentBalance2 = Number(localStorage.getItem("aviator-balance") || 0);
        if (currentBalance2 - state.userInfo.s.betAmount < 0) {
          toast.error("Your balance is not enough");
          betStatus.sbetState = false;
          betStatus.sbetted = false;
          return;
        }
        attrs.userInfo.balance = currentBalance2 - state.userInfo.s.betAmount;
        socket.emit("playBet", data);
        betStatus.sbetState = false;
        betStatus.sbetted = true;
        setUserBetState(betStatus);
      }
    }
  }, [gameState.GameState, userBetState.fbetState, userBetState.sbetState]);

  const getMyBets = async () => {
    const token = userInfo.token || localStorage.getItem("aviator-token") || "";
    if (!token) return;
    try {
      const response = await fetch(`${config.api}/my-info`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({}),
      });
      if (response.ok) {
        const data = await response.json();
        if (data.status) update({ myBets: data.data as GameHistory[] });
      }
    } catch (error) {
      console.log("getMyBets", error);
    }
  };

  useEffect(() => {
    if (gameState.GameState === "BET") getMyBets();
  }, [gameState.GameState]);

  const updateUserInfo = (attrs: Partial<UserType>) => {
    setUserInfo((prev) => ({ ...prev, ...attrs }));
    if (attrs.token) {
      socket.emit("updateToken", { token: attrs.token });
    }
  };

  const handleGetSeed = () => {};

  const handleGetSeedOfRound = async (id: number): Promise<SeedDetailsType> => {
    try {
      const response = await fetch(`${config.api}/game/seed/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      });
      if (response.ok) return await response.json();
      throw new Error("Failed to fetch seed details");
    } catch (error) {
      return { createdAt: new Date().toISOString(), serverSeed: "", seedOfUsers: [], flyDetailID: id };
    }
  };

  const handlePlaceBet = () => {};
  const toggleMsgTab = () => setMsgTab((prev) => !prev);
  const handleChangeUserSeed = (seed: string) => {};

  return (
    <Context.Provider
      value={{
        ...state,
        ...gameState,
        ...userBetState,
        ...betLimit,
        userInfo,
        state,
        socket,
        msgData,
        msgTab,
        msgReceived,
        setMsgReceived,
        platformLoading,
        errorBackend,
        unityState: unity.unityState,
        unityLoading: unity.unityLoading,
        currentProgress: unity.currentProgress,
        globalUserInfo,
        bettedUsers,
        previousHand,
        history,
        rechargeState,
        onlineCount,
        secure,
        myUnityContext: sharedUnityContext,
        userSeedText,
        currentTarget,
        fLoading,
        setFLoading,
        sLoading,
        setSLoading,
        setCurrentTarget,
        update: (attrs) => setState((prev) => ({ ...prev, ...attrs })),
        updateUserInfo,
        getMyBets,
        updateUserBetState,
        setMsgData,
        handleGetSeed,
        handleGetSeedOfRound,
        handlePlaceBet,
        toggleMsgTab,
        handleChangeUserSeed,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default Context;
